import { Breadcrumbs as UnstyledBreadcrumbs } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import styled from 'styled-components'

import { RequireAuth } from '../core/AccountProvider'
import { useAccountQuery, usePersonQuery } from '../core/queries'

const AccountBarWrapper = styled.div`
  background-color: #f2f0ed;
  padding: 6px 10px;
  margin: 0;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  font-size: 12px;

  strong {
    font-weight: bold;
  }
`

const Breadcrumbs = styled(UnstyledBreadcrumbs)`
  display: inline-block;
  font-size: 12px;
`

const Company = styled.span`
  margin: 0 20px;
`

export default ({ displayCompany = false, className }) => {
  const { data: accountData, isLoading: isAccountLoading } = useAccountQuery()
  const { data: personData, isLoading: isPersonLoading } = usePersonQuery()

  return (
    <AccountBarWrapper className={className}>
      {displayCompany && <Company>Purple Wave, Inc.</Company>}
      <RequireAuth>
        <Breadcrumbs>
          <strong>
            {isPersonLoading ? (
              <Skeleton variant='text' width={100} />
            ) : (
              <>
                {personData.firstName} {personData.lastName}
              </>
            )}
          </strong>
          <span>
            Account:&nbsp;
            <strong>
              {isAccountLoading ? (
                <Skeleton
                  variant='text'
                  sx={{ display: 'inline-block' }}
                  width={50}
                />
              ) : (
                accountData.id
              )}
            </strong>
          </span>
        </Breadcrumbs>
      </RequireAuth>
    </AccountBarWrapper>
  )
}
